/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) System Print Icon component.
 */
export const SystemPrintIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M22.0444 12.083H1V20.4602H22.0444V12.083Z' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
      <path d='M18.1521 11.9626V8.17821L13.4848 4H4.89209V11.9626' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
      <path d='M5.90771 20.0745V17.2227H17.1367V20.0745' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
      <path d='M13.4849 4V8.31085H17.9905' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
    </svg>
  );
};

export default SystemPrintIcon;
